
import { Module } from '../types';

export const ADVANCED_TESTING_MODULE: Module = {
  id: "advanced-1",
  title: "Testing React Applications",
  description: "Learn advanced testing strategies for React applications",
  duration: "90 minutes",
  difficulty: "advanced", // Add missing difficulty
  content: `
# Testing React Applications

Learn how to write comprehensive tests for React applications using Jest, React Testing Library, and other modern testing tools.

## Testing Fundamentals

Understanding the testing pyramid and how to apply it to React applications.

## Unit Testing Components

Learn to test individual React components in isolation.

## Integration Testing

Test how components work together and interact with external services.

## End-to-End Testing

Test complete user workflows using tools like Cypress or Playwright.
  `,
  codeExamples: [
    {
      title: "Testing a React Component",
      code: `import { render, screen, fireEvent } from '@testing-library/react';
import Button from './Button';

describe('Button Component', () => {
  test('renders with correct text', () => {
    render(<Button>Click me</Button>);
    expect(screen.getByText('Click me')).toBeInTheDocument();
  });

  test('calls onClick handler when clicked', () => {
    const handleClick = jest.fn();
    render(<Button onClick={handleClick}>Click me</Button>);
    
    fireEvent.click(screen.getByText('Click me'));
    expect(handleClick).toHaveBeenCalledTimes(1);
  });
});`,
      explanation: "Example of testing a React component using React Testing Library",
      language: "javascript"
    }
  ],
  practice: {
    task: "Write tests for a TodoList component",
    starter: `import { render, screen } from '@testing-library/react';
import TodoList from './TodoList';

// Write your tests here`,
    solution: `import { render, screen, fireEvent } from '@testing-library/react';
import TodoList from './TodoList';

describe('TodoList Component', () => {
  test('renders empty list initially', () => {
    render(<TodoList />);
    expect(screen.getByText('No todos yet')).toBeInTheDocument();
  });

  test('adds new todo when form is submitted', () => {
    render(<TodoList />);
    const input = screen.getByPlaceholderText('Add new todo');
    const button = screen.getByText('Add Todo');
    
    fireEvent.change(input, { target: { value: 'New todo' } });
    fireEvent.click(button);
    
    expect(screen.getByText('New todo')).toBeInTheDocument();
  });
});`,
    hints: [
      "Use render to mount the component",
      "Use screen.getByText to find elements",
      "Use fireEvent for user interactions",
      "Use expect with jest matchers for assertions"
    ]
  }
};
